export default function insertLattes(lattes){
    if(lattes != ""){
        return <a className="btn btn-sm btn-outline-secondary" href={lattes} target="_blank" role="button">Lattes »</a>            
    }
}